{
	"backLinkTitle": "Zpět na Správa prohlášení"
}
